export default __webpack_public_path__ + "static/media/group_3.c98d42ff.png";